import { LEGAL_ADMIN, LEGAL_DOCUMENT_EFFECTIVE_DATE, LEGAL_DOCUMENT_VERSION } from './constants'
import type { LegalDocumentContent } from './types'

export const privacyContent: LegalDocumentContent = {
  slug: 'privacy',
  documentTitle: 'Конфиденциальность',
  h1: 'Конфиденциальность',
  version: LEGAL_DOCUMENT_VERSION,
  effectiveDate: LEGAL_DOCUMENT_EFFECTIVE_DATE,
  intro: [
    `Этот текст объясняет, какие данные собирает площадка «${LEGAL_ADMIN.brandName}» (${LEGAL_ADMIN.siteHost}) и зачем.`,
    `Площадку ведёт ${LEGAL_ADMIN.displayName}. Контакт: ${LEGAL_ADMIN.contactEmail}.`,
    'В смысле закона о персональных данных Администрация определяет, какие данные нужны для работы сервиса. Это не означает статус коммерческой организации или юридического лица.',
  ],
  sections: [
    {
      id: 'what',
      title: '1. Какие данные',
      bullets: [
        'email — для входа и служебных писем;',
        'имя, фамилия, описание профиля, аватар и другие поля, которые вы заполняете;',
        'сведения об участии в проектах, командах и соц-заказах;',
        'ваш контент: проекты, комментарии, заявки и т.п.;',
        'настройки уведомлений и приватности;',
        'технические данные (например, IP, данные браузера, журналы) — в объёме, нужном для безопасности и работы сайта.',
      ],
    },
    {
      id: 'why',
      title: '2. Зачем',
      bullets: [
        'регистрация и вход;',
        'работа функций площадки;',
        'уведомления (in-app, email, web-push — по вашим настройкам и разрешениям);',
        'коды для входа;',
        'безопасность и модерация;',
        'ответы на ваши обращения.',
      ],
    },
    {
      id: 'sharing',
      title: '3. Кому передаём',
      paragraphs: [
        'Мы не продаём персональные данные и не передаём их третьим лицам для рекламы или маркетинга.',
        'Данные могут обрабатываться техническими партнёрами (хостинг, доставка email) только чтобы сайт работал.',
        'Трансграничная передача намеренно не организуется, кроме случаев, прямо предусмотренных законом.',
      ],
    },
    {
      id: 'security',
      title: '4. Безопасность и риски',
      paragraphs: [
        'Администрация принимает разумные меры защиты данных, но не гарантирует абсолютную сохранность.',
        'Интернет и любые онлайн-сервисы сопряжены с риском сбоев, взлома и утечек. Пользуясь площадкой, вы принимаете эти риски на себя.',
        'Не указывайте на сайте сведения, которые критичны при раскрытии.',
      ],
    },
    {
      id: 'cookies',
      title: '5. Cookie',
      paragraphs: [
        'Подробности — в разделе [[cookies|Cookie]]. Для входа используются необходимые cookie; рекламных и аналитических cookie в текущей версии нет.',
      ],
    },
    {
      id: 'rights',
      title: '6. Ваши права',
      paragraphs: [
        'Управлять своими данными вы можете самостоятельно в аккаунте: удалить отдельные материалы (например, свои комментарии, проекты, команды и другие публикации, которые вам доступны для удаления) или полностью удалить аккаунт.',
        'После удаления аккаунта связанные с ним данные обрабатываются по правилам площадки; часть сведений может оставаться в обезличенном или служебном виде в пределах, нужных для работы сервиса и закона.',
        `Если нужна помощь с уточнением данных — напишите на ${LEGAL_ADMIN.contactEmail}. Удаление контента и аккаунта — прежде всего ваша ответственность через интерфейс площадки.`,
      ],
    },
    {
      id: 'retention',
      title: '7. Срок хранения',
      paragraphs: [
        'Данные хранятся, пока существует аккаунт, и после удаления — в объёме и сроки, нужные для работы сервиса и требований закона.',
      ],
    },
    {
      id: 'changes',
      title: '8. Изменения',
      paragraphs: [
        'Актуальная редакция публикуется на этой странице с датой и версией.',
      ],
    },
  ],
  relatedLinks: [
    { label: 'Правила сообщества', slug: 'rules' },
    { label: 'Cookie', slug: 'cookies' },
  ],
}
